<template>
    <div class="mit-manager-dashboard-page mit-page">
        <!-- TODO
        Add my next Reservation(s) widget
        Add Busiest Reservation Times widget -->
        <v-container fluid>
            <BaseMitLoading :show="loadingSpaceUsage || loadingSpaceUsageByDay" :overlayFullscreen="false"/>
            <v-card class="mit-info-card" style="width:100%">
                <v-card-title color="white">
                    Reservation Stats
                    <v-spacer/>
                        <v-menu v-model="dateStartMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field class="text--body1" dense v-model="computedStartDateFormatted" readonly label="Start Date" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" style="max-width: 200px;"></v-text-field>
                            </template>
                            <v-date-picker v-model="startDateString" no-title @input="startDateChanged()"></v-date-picker>
                        </v-menu>
                        <v-menu v-model="dateEndMenu" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="auto">
                            <template v-slot:activator="{ on, attrs }">
                            <v-text-field dense v-model="computedEndDateFormatted" readonly label="End Date" prepend-icon="mdi-calendar" v-bind="attrs" v-on="on" style="max-width: 200px;"></v-text-field>
                            </template>
                            <v-date-picker v-model="endDateString" no-title @input="endDateChanged()"></v-date-picker>
                        </v-menu>
                </v-card-title>
                <v-card-subtitle class="caption">Reservation stats and info</v-card-subtitle>
                <v-divider></v-divider>
                
                <v-card-text class="grey lighten-5">
                        <v-row>
                            <v-col col="12">
                                <v-card class="" elevation="4">
                                    <v-card-title>Usage by Space</v-card-title>
                                    <v-card-text>
                                        <MitLineBarChart v-if="spaceUseageData.datasets" chartId="mitSpaceUsage" chartType="bar" :data="spaceUseageData"/>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <!-- <v-col col="12" md="6">
                                <v-card class="" elevation="4">
                                    <v-card-title></v-card-title>
                                    <v-card-text>
                                        Usage over time 
                                        group by month, week, day
                                        Filter by space
                                    </v-card-text>
                                </v-card>
                            </v-col> -->
                        </v-row>
                        <v-row>
                            <v-col col="12">
                                <v-card class="" elevation="4">
                                    <v-card-title>Usage by Day of Week</v-card-title>
                                    <v-card-text>
                                        <MitLineBarChart v-if="spaceUseageDataByDay.datasets" chartId="mitSpaceUsageByDay" chartType="bar" :data="spaceUseageDataByDay"/>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                            <!-- <v-col col="12" md="6">
                                <v-card class="" elevation="4">
                                    <v-card-title></v-card-title>
                                    <v-card-text>
                                        Usage over time 
                                        group by month, week, day
                                        Filter by space
                                    </v-card-text>
                                </v-card>
                            </v-col> -->
                        </v-row>
                    </v-card-text>
                </v-card>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import BaseMitLoading from '../../../base/components/BaseMitLoading.vue';

import MitReservationAnalyticsService from '../../services/MitReservationAnalyticsService.js';
import MitLineBarChart from '../../components/MitLineBarChart.vue';

  export default {
    name: 'MitDashboardPage',
    components: {
        BaseMitLoading,
        MitLineBarChart
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    data: function() {
      return {
            loadingSpaceUsage:false,
            loadingSpaceUsageByDay:false,
            dateStartMenu:false,
            dateEndMenu:false,
            startDateMoment: moment().startOf('day').subtract(1, 'years'),
            endDateMoment:moment().endOf('day'),
            startDateString:null,
            endDateString:null,
            spaceUseageData:{
                datasets:null,
                title:'Space Usage',
                labelX:'Space',
                labelY:'Hours/Counts'
            },
            spaceUseageDataByDay:{
                datasets:null,
                title:'Space Usage By Day',
                labelX:'Space',
                labelY:'Hours/Counts'
            }
            // timeseriesChart: {
            //     datasets:null,
            //     title:'Data Used ('+currentUnit.unit+')',
            //     labelX:'',
            //     labelY:'Data ('+currentUnit.unit+')'
            // }
      }
    },
    mounted() {
        this.updateDatesFromMoment();
        this.refreshAllCharts();
    },
    computed: {
      computedStartDateFormatted () {
        return this.startDateMoment.format('MMM Do YYYY')
      },
      computedEndDateFormatted () {
        return this.endDateMoment.format('MMM Do YYYY')
      },
      computedDateFormatted () {
        return date ? moment(date).format('MMM Do YYYY') : ''
      }
    },
    methods:{
        refreshAllCharts(){
            this.getSpaceUsage(this.startDateMoment, this.endDateMoment);
            this.getSpaceUsageByDay(this.startDateMoment, this.endDateMoment);
        },
        updateDatesFromMoment(){
            this.startDateString = this.startDateMoment.format('YYYY-MM-DD');
            this.endDateString = this.endDateMoment.format('YYYY-MM-DD');
        },
        updateMomentFromDates(){
            this.startDateMoment = moment(this.startDateString).startOf('day');
            this.endDateMoment = moment(this.endDateString).endOf('day');
        },
        startDateChanged(){
            this.updateMomentFromDates();
            this.refreshAllCharts();
        },
        endDateChanged(){
            this.updateMomentFromDates();
            this.refreshAllCharts();
        },
        getSpaceUsage(startDate, endDate){
            this.loadingSpaceUsage = true;
            this.spaceUseageData.datasets = null;//important for refresh so the child chart control updates
            MitReservationAnalyticsService.getReservationsSpaceUsage(startDate, endDate)
                .then((data) => {
                    this.loadingSpaceUsage = false;
                    this.spaceUseageData = data;
                })
                .catch((error) => {
                    this.loadingSpaceUsage = false;
                    console.log('ERROR:', error);
                });

        },
        getSpaceUsageByDay(startDate, endDate){
            this.loadingSpaceUsageByDay = true;
            this.spaceUseageDataByDay.datasets = null;//important for refresh so the child chart control updates
            MitReservationAnalyticsService.getReservationsSpaceUsageByDay(startDate, endDate)
                .then((data) => {
                    this.loadingSpaceUsageByDay = false;
                    this.spaceUseageDataByDay = data;
                })
                .catch((error) => {
                    this.loadingSpaceUsageByDay = false;
                    console.log('ERROR:', error);
                });

        }
    }

  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
